module.exports = __webpack_public_path__ + "img/BG.59bcc2f0.png";